module.exports = __webpack_public_path__ + "static/media/menu_white.c0aae39e.svg";